import { AlertOptions } from '@ionic/core';
import { ErrorCodeKey } from 'src/app/models';

interface ErrorMessage {
  title: string;
  message: string;
}

export class SelfServiceConstant {
  static readonly RESIDENT_TYPE = 'Resident';
  static readonly STAFF_TYPE = 'Staff Member';
  static readonly GUEST_TYPE = 'Guest';

  static readonly REACHED_MAX_ALERT_OPTS = (
    headerText: string,
    messageText: string,
    buttonText: string
  ) =>
    <AlertOptions>{
      mode: 'ios',
      cssClass: 'reached-max-amount-alert',
      header: headerText,
      message: messageText,
      buttons: [buttonText]
    };
}

export class SelfServiceHomeConstants {
  static readonly IDLE_TIME = 120;
  // Translation keys for error messages - translations are in i18n files
  static readonly ERROR_CODE_TRANSLATION_KEYS: {
    [key in ErrorCodeKey]: ErrorMessage;
  } = {
    [ErrorCodeKey.MultipleDiners]: {
      title: 'common.warning',
      message: 'selfService.multipleDinersSameBadge'
    },
    [ErrorCodeKey.NotFoundDiner]: {
      title: 'common.error',
      message: 'selfService.idNotFound'
    }
  };
}
